import React from 'react';
export const ZipcodeContext = React.createContext({});
export default ({
  initialZipInfo,
  children
}) => React.createElement(ZipcodeContext.Provider, {
  value: initialZipInfo
}, children);